import React, { useEffect, useState, useRef  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';
import 'remixicon/fonts/remixicon.css'
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

const getPeopleContent = (array = []) =>
  array.map((obj, item) => {
    obj[0] = item;
    return obj;
  }, {}
);

const IsotopeView = () => {

    const dispatch = useDispatch();
    const people = useSelector((state) =>
        getPeopleContent(state.search.subrequests.person?.items),
    );

    const content = useSelector((state) => state.workflow.transition);

    useEffect(() => {
        dispatch(
          searchContent(
            '/',
            {
              portal_type: ['person'],
              b_size: 1000,
              fullobjects: true,
            },
            'person',
          ),
        );
    }, [dispatch, content]);

    return(
        <>    
            <Grid className='gridIsotope' container spacing={{md:8, sm: 8}} rowSpacing={{xs: 8}}>
                    {people.map((person) => (
                        <Grid item key={person.UID}>
                            <Image className='gridImg' src={person.img_field.scales.teaser.download} alt={person.img_field.filename} loading="lazy" />
                            <div className='gridContent'>
                                <div className='gridContentNameDiv'><p className='gridContentName'>{ person.name_field }</p></div>
                                <div className='stackWrapper'>
                                    <Stack spacing={2}>
                                        <p>{ person.position_field }</p>
                                    </Stack>
                                    <Stack spacing={2}>
                                        {person.position_field != null ? (
                                            <div className='gridContentTagContainer'><button className='gridContentTag'><p className='gridContentPosition'>{person.position_field}</p></button></div>
                                        ) : (<p></p>)}
                                    </Stack>
                                </div>

                            </div>
                           	{person.related_field != null &&
                                <div className='gridHover'>
                                    <a className='gridHoverBtn' href={person.related_field} target='_self'>Weiteres</a>
                                </div>
                            }
                        </Grid>
                    ))}
            </Grid>
        </>
    );
};

export default IsotopeView;